import { usePlatformSetting } from "@/hooks/usePlatformSettings";

/**
 * Admin kill-switch: όταν είναι ON, κρύβεται ολόκληρο το Market
 * και αποκλείεται η απευθείας πρόσβαση στο /chat/shop.
 *
 * Default: false (το κατάστημα φαίνεται κανονικά).
 */
export function useHideCoinShop() {
  const { data } = usePlatformSetting("hide_coin_shop");
  if (data === undefined) return null;
  // Fail closed when the setting cannot be read (for example before auth is ready).
  if (data === null) return true;
  return data === true || data === "true" || data === 1;
}

export default useHideCoinShop;
